module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bar-wrap"
  }, [_c('div', {
    staticClass: "title"
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('p', [_vm._v("67.95%")]), _vm._v(" "), _c('p', [_vm._v("女")]), _vm._v(" "), _c('p', [_c('countTo', {
    staticClass: "count",
    attrs: {
      "startVal": 0,
      "endVal": 634,
      "duration": 5000
    }
  }), _c('span', [_vm._v("人")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v("32.05%")]), _vm._v(" "), _c('p', [_vm._v("男")]), _vm._v(" "), _c('p', [_c('countTo', {
    staticClass: "count",
    attrs: {
      "startVal": 0,
      "endVal": 430,
      "duration": 5000
    }
  }), _c('span', [_vm._v("人")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-765d6bbc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/yinxiao/components/item1/index.vue
// module id = 2047
// module chunks = 2